export { useLocationFromPath } from '@guiker/router'
